import { PreloadedQuery } from 'react-relay';

import { createRelayResource } from '@townsquare/relay-utils';
import { getAggRelayEnvironment } from '@townsquare/relay-utils/agg-environment';
import { RouteResource } from '@townsquare/router/routing-types';
import type { ResourceContext } from '@townsquare/router/types';
import { fg } from '@townsquare/stat-sig/gate';

import GoalCapabilitiesQuery, {
	GoalCapabilitiesQuery as GoalCapabilitiesQueryType,
} from '../components/__generated__/GoalCapabilitiesQuery.graphql';

export const goalCapabilitiesResource: RouteResource<
	PreloadedQuery<GoalCapabilitiesQueryType, Record<string, unknown>>
> = createRelayResource<GoalCapabilitiesQueryType>({
	getQuery: (_, resourceContext) => {
		const containerId = (resourceContext as ResourceContext).collabContext?.contextId ?? '';

		return {
			query: GoalCapabilitiesQuery,
			environment: getAggRelayEnvironment(),
			variables: {
				containerId,
				isM3GroupPermsEnabled: fg('townsquare_m3_group_permissions'),
			},
		};
	},
});
